import React from "react";

const Training = () => (
  <section id="training">
    <div className="container">
      <div className="title-block">
        <h2>Training Workshops</h2>
        <p>Register for the challenge and you will receive updates on upcoming training workshops. </p>
        <p>Please note that only successfully registered participants will receive invitation and details of the training workshops.</p>
      </div>
      <div className="row">
        <div className="col-md-4 offset-md-2">
          <div className="box box-1">
            <small>26 Jan 2019</small>
            <h4>
              Advanced Training
              <p>By <span className="tag">YiDu AI</span></p>
              <p>(Registration is closed)</p>
            </h4>
            <ul>
              <li>Overview of Tensorflow</li>
              <li>Elements of Tensorflow</li>
              <li>Visualization of Computational Graph</li>
              <li>Train your model with Tensorflow</li>
              <li>Your first neural Network with Tensorflow</li>
              <li>Advanced topics in Tensorflow</li>
            </ul>
          </div>
        </div>
        <div className="col-md-4">
          <div className="box box-1">
            <small>2 Feb 2019</small>
            <h4>
              Beginners Training
              <p>By <span className="tag">YiDu AI</span></p>
            </h4>
            <p>(Registration is closed)</p>
            <ul>
              <li>Introduction to Python</li>
              <li>Introduction to Data Science and Machine Learning</li>
              <li>Linear Regression</li>
              <li>Logistics Regression</li>
              <li>Decision Tree</li>
              <li>Ensemble Learning</li>
              <li>Support Vector Machine</li>
              <li>Hands-on Project</li>
            </ul>
          </div>
        </div>
        <div className="col-md-4 offset-md-2">
          <div className="box">
            <small>9 Jan - 30 Jan 2019</small>
            <h4>Beginners Training
              <p>By <span className="tag">UpCode Academy</span></p>
              <p>(Registration is closed)</p>
            </h4>
            <ul>
              <li>Intro to Deep Learning</li>
              <li>CNN Introduction</li>
              <li>Improving CNNs</li>
              <li>How a CNN learns</li>
            </ul>
          </div>
        </div>
        <div className="col-md-4">
          <div className="box">
            <small>12 Jan - 13 Feb 2019</small>
            <h4>Advanced Training
              <p>By <span className="tag">UpCode Academy</span></p>
              <p>(Registration is closed)</p>
            </h4>
            <ul>
              <li>Overfitting</li>
              <li>CNN + RNN</li>
              <li>CNNs Top Architectures</li>
              <li>NLP</li>
            </ul>
          </div>
        </div>
        <div className="col-md-8 offset-md-2">
          <div className="box">
            <small>16 Feb 2019</small>
            <h4>Combined Training
            <p>(Registration is closed)</p>
            </h4>
            <h5>Course #1- Recommended for Beginner participants</h5>
            <h6>Data Analysis with pandas by Hackwagon Academy</h6>
            <ul>
              <li>Understanding the basic functionalities of pandas library</li>
              <li>Application of pandas in preparing data and descriptive data analysis</li>
              <li>Manipulation of data into appropriate formats and data cleaning with pandas</li>
            </ul>
            <h6>Data Science 101 by General Assembly</h6>
            <ul>
              <li>Learn what data scientists do and the types of problems they solve. Walk through the typical data science workflow and see how the pros identify powerful business predictions.</li>
              <li>Explore key tools and processes data scientists use to analyze, visualize, and model data and apply what you’ve learned to a data set to produce your own recommendations.</li>
            </ul>
            <hr />
            <h5>Course #2- Recommended for Advanced participants</h5>
            <h6>Product Classification by Code Gakko</h6>
            <ul>
              <li>How to set up a simple data processing pipeline</li>
              <li>Understanding what state-of-the-art neural networks look like</li>
              <li>Using neural networks to classify and locate product in images</li>
            </ul>
            <h6>Fashion product recommendation system by UpCode Academy </h6>
            <ul>
              <li>Setting up a feature recognition system for fashion products</li>
              <li>Generating fashion vector for images</li>
              <li>Getting recommendations</li>
            </ul>
          </div>
        </div>
        <div className="col-md-8 offset-md-2">
          <div className="box">
            <small>16 Feb 2019</small>
            <h4>Deep Learning for Pure Beginners
            <p>By
              <span className="tag">SG Code Campus</span>
              </p>
              <p>(Registration is closed)</p>
            </h4>
            <ul>
              <li>What is Deep Learning?</li>
              <li>Build your first neural network with TensorFlow and Keras</li>
              <li>Use cases for Deep Learning</li>
            </ul>
          </div>
        </div>
      </div>
      {/* <div className="note">
        <ol>
          <li>For participants who are keen to attend both the Beginners and Advanced Training workshops, please contact <a href="mailto:ndsc@shopee.com">ndsc@shopee.com</a> and check for available vacancies.</li>
          <li>Participants who attend the training workshops on 15 or 16 Dec 2018 must pay a deposit of SGD 20 per pax.</li>
          <li>Participants will be refunded only if they participate in the National Data Science Challenge and submit the project successfully as a team.</li>
        </ol>
      </div> */}
    </div>
  </section>
);

export default Training;